import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_BASE = `${BACKEND_URL}/api`;

// Session lives in an httpOnly cookie; the custom header is the CSRF guard the API requires for writes.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'X-Requested-With': 'crawler' },
});

const listeners = new Set();
export const onAuthEvent = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || '';
    if (!url.startsWith('/auth/login') && !url.startsWith('/auth/mfa')) {
      if (status === 401) listeners.forEach((fn) => fn('logged_out'));
      if (status === 403 && err.response?.data?.detail === 'password_change_required') {
        listeners.forEach((fn) => fn('password_change_required'));
      }
    }
    return Promise.reject(err);
  }
);

export const exportUrl = (params) => `${API_BASE}/domains/export/csv?${params.toString()}`;

export const safeExternalUrl = (url) => {
  try {
    const u = new URL(url);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.href : null;
  } catch {
    return null;
  }
};

export default api;
export { API_BASE, BACKEND_URL };
